// extracted by mini-css-extract-plugin
module.exports = {"load-more":"load-more-2Rqlh","loadMore":"load-more-2Rqlh"};